import { Application } from '../../remote-api/models'
import { ARMApplication } from 'src/remote-api/models'

export type ApplicationData = {
  orgId: string,
  orgName?: string,
  envId: string,
  envName?: string,
  appId: string,
  appName?: string,
  targetId?: string,
  requestVolume?: string,
  successfulRequests?: string,
  responseTime?: string,
  failedRequests?: string,
  cpuUtilization?: string,
  memoryUtilization?: string,
  totalMemory?: string,
  memoryPressure?: string,
}

export type ReportsApplication = {
  id: string,
  name: string,
  orgId: string,
  orgName: string,
  envId: string,
  envName: string,
  targetType: string,
  targetId?: string
}

export type ReportsState = {
  isLoading: boolean,
  selectedBusinessGroup: string,
  selectedEnvironment: string,
  selectedType: string,
  applicationsData: ApplicationData[],
  applications: ReportsApplication[]
  applicationsARM: ARMApplication[],
}

export enum ReportsTypes {
  Requests = 'requests',
  Performance = 'performance',
  Failures = 'failures',
  CpuUtilization = 'cpu-utilization',
  MemoryUtilization = 'memory-utilization',
}

export const reportsTimeOptions = [
  {label: 'Last 24 hours', value: {from: 'now-24h', to: 'now'}},
  {label: 'Last 7 days', value: {from: 'now-7d', to: 'now'}},
  {label: 'Last 15 days', value: {from: 'now-15d', to: 'now'}},
  {label: 'Last 30 days', value: {from: 'now-30d', to: 'now'}},
  {label: 'Last 90 days', value: {from: 'now-90d', to: 'now'}}
]

export const environmentsOptions = [
  {value: 'sandbox', label: 'All Sandbox types'},
  {value: 'design', label: 'All Design types'},
  {value: 'production', label: 'All Production types'}
]

export const reportsButtons = [
  {label: 'Requests'},
  {label: 'Performance'},
  {label: 'Failures'},
  {label: 'CPU Utilization'},
  {label: 'Memory Utilization'}
]

export const pceReportsButtons = [
  {label: 'Requests'},
  {label: 'Performance'},
  {label: 'Failures'}
];

export const getApplicationName = (appId: string, appName?: string, applications?: Application[], reportsApplications?: ReportsApplication[]) => {
  let resolvedAppName

  if (reportsApplications) {
    const app = reportsApplications.find(app => app.id === appId || app.name === appId)
    resolvedAppName = app && app.name
  } else if (applications) {
    const app = applications.find(app => app.id === appId || app.name === appId)
    resolvedAppName = app && app.name
  }

  if (!resolvedAppName) {
    resolvedAppName = appName || appId.split('.')[0]
  }

  return resolvedAppName
}

export const appIdSort = (rowA: ApplicationData, rowB: ApplicationData) => {
  const rowAAppName = rowA.appName ? rowA.appName : rowA.appId.split('.')[0]
  const rowBAppName = rowB.appName ? rowB.appName : rowB.appId.split('.')[0]
  return rowAAppName.localeCompare(rowBAppName)
}